import { Form, Input } from "antd";

export default function Name(props) {
  return (
    <Form.Item
      {...props}
      name="display_name"
      className="w-full"
      label="Name"
      rules={[
        {
          required: true,
          message: "Name is required",
        },
      ]}
    >
      <Input className="w-full" placeholder="Enter user real name" />
    </Form.Item>
  );
}
